import i18n from 'services/i18n'
import { userMetadataKeys } from 'services/yggdrasil/setter'
import config from 'services/config'

const state = {
    languages: [
        { label: 'English', countryCode: 'en' },
        { label: 'Suomi', countryCode: 'fi' },
        { label: 'Norsk', countryCode: 'no' },
        { label: 'Svenska', countryCode: 'se' }
    ],
    selectedCountryCode: localStorage.getItem('totemLocale') || config.appLanguage
}

const mutations = {
    SET_SELECTED_LANGUAGE (state, languageCountryCode) {
        i18n.locale = languageCountryCode
        localStorage.setItem('totemLocale', i18n.locale)
        state.selectedCountryCode = languageCountryCode
    }
}

const actions = {
    async setSelectedLanguage (store, languageCountryCode) {
        store.commit('SET_SELECTED_LANGUAGE', languageCountryCode)
        const isLoggedIn = store.rootGetters['isLoggedIn']
        if (isLoggedIn) {
            store.dispatch('User/setMetadata', { key: userMetadataKeys.language, value: languageCountryCode }, { root: true })
        }
        if (!store.rootGetters['Menu/getIsDesktop']) {
            store.dispatch('Menu/createMenuLanguages', {}, { root: true })
            if (isLoggedIn) {
                store.dispatch('Menu/createMenuLogged', {}, { root: true })
            } else {
                store.dispatch('Menu/createMenuNonLogged', {}, { root: true })
            }
        }
    }
}

const getters = {
    getLanguages: (state) => state.languages,
    getSelectedCountryCode: (state) => state.selectedCountryCode
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
